/* global System:readonly */

import "systemjs";
import "systemjs/dist/extras/named-register";
import * as CapitalRxShell from "..";
import * as CapitalRxShellAuth from "capitalrx-shell-auth";

/** Initializes the set of libraries to be shared by the shell to all modules. */
export function initializeSharedLibraries(): void {
  System.register("capitalrx-shell", [], (_export) => {
    _export(CapitalRxShell);
    _export("default", CapitalRxShell);
    return {};
  });

  System.register("capitalrx-shell-auth", [], (_export) => {
    _export(CapitalRxShellAuth);
    _export("default", CapitalRxShellAuth);
    return {};
  });
}
